; (function () {
  const blockedDomains = [
    /(^|\.)mailmunch\.co$/,
    /(^|\.)judge\.me$/,
    /(^|\.)cozycountryredirectii\.addons\.business$/,
    /(^|\.)pixel\.orichi\.info$/,
    /(^|\.)avada\.io$/
  ];

  function isBlocked(url) {
    try {
      const host = new URL(url, location.href).hostname;
      return blockedDomains.some(rx => rx.test(host));
    } catch {
      return false;
    }
  }

  // override document.createElement, to block src + href
  const origCreate = Document.prototype.createElement;
  Document.prototype.createElement = function (tagName, options) {
    const el = origCreate.call(this, tagName, options);
    ['src', 'href'].forEach(attr => {
      if (attr in el) {
        const desc = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(el), attr);
        Object.defineProperty(el, attr, {
          configurable: true,
          enumerable: true,
          get() { return desc.get.call(this); },
          set(val) {
            if (isBlocked(val)) {
              console.warn(`Blocked ${tagName}.${attr}:`, val);
              return;
            }
            desc.set.call(this, val);
          }
        });
      }
    });
    return el;
  };

  // override fetch()
  const origFetch = window.fetch;
  window.fetch = function (input, init) {
    const url = (typeof input === 'string') ? input : input.url;
    if (isBlocked(url)) {
      console.warn('Blocked fetch:', url);
      return Promise.resolve(new Response('', {
        status: 204,
        statusText: 'No Content'
      }));
    }
    return origFetch.call(this, input, init);
  };

  // override XMLHttpRequest.open()
  const origXhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    if (isBlocked(url)) {
      console.warn('Blocked XHR:', url);
      return;
    }
    return origXhrOpen.call(this, method, url, ...rest);
  };

  // MutationObserver for script tags in HTML
  const obs = new MutationObserver(records => {
    for (const rec of records) {
      for (const node of rec.addedNodes) {
        if (
          node.tagName === 'SCRIPT' &&
          node.src &&
          isBlocked(node.src)
        ) {
          node.remove();
          console.warn('Removed inline script tag:', node.src);
        }
      }
    }
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });

  console.log('Domain blocking active');
})();
